import * as React from 'react';
import PropTypes from 'prop-types';
import { IMaskInput } from 'react-imask';

const TextMaskPhone = React.forwardRef(function TextMaskCustom(props, ref) {
  const { onChange, ...other } = props;

  let mask = '000-0000-0000';

  return (
    <IMaskInput
      {...other}
      mask={mask}
      definitions={{}}
      inputRef={ref}
      onAccept={(value) => onChange({ target: { name: props.name, value } })}
      overwrite
    />
  );
});

TextMaskPhone.propTypes = {
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default TextMaskPhone;
